import React from 'react';
import { motion } from 'framer-motion';
import { FlowerIcon } from './icons/Icons';
import { useLanguage } from '../LanguageContext';
export const PromiseSection = () => {
  const {
    language
  } = useLanguage();
  const promises = [{
    title: language === 'es' ? 'PRESENCIA TOTAL' : 'TOTAL PRESENCE',
    desc: language === 'es' ? 'Cada vez que entras a nuestro studio, eres la única prioridad. Sin prisa. Sin protocolos genéricos. Tu tiempo y tu piel merecen atención completa.' : 'Every time you enter our studio, you are the only priority. No rush. No generic protocols. Your time and your skin deserve complete attention.'
  }, {
    title: language === 'es' ? 'PROFESIONALISMO REAL' : 'REAL PROFESSIONALISM',
    desc: language === 'es' ? 'María Fernanda es Esthetician certificada y Medical Assistant — dos expertises que se combinan para ofrecerte tratamientos seguros, efectivos y con respaldo profesional.' : 'María Fernanda is a certified Esthetician and Medical Assistant — two expertises that combine to offer you safe, effective treatments with professional backing.'
  }, {
    title: language === 'es' ? 'RESULTADOS HONESTOS' : 'HONEST RESULTS',
    desc: language === 'es' ? 'Si un tratamiento no es el correcto para ti en este momento, te lo diremos. Así se construye confianza real. Así se construyen clientes de por vida.' : 'If a treatment is not right for you at this time, we will tell you. That is how real trust is built. That is how lifelong clients are built.'
  }];
  return <section className="py-12 md:py-16 bg-brand-cream relative border-t border-brand-gold/10" data-id="element-355">
      <div className="container mx-auto px-6 max-w-5xl text-center" data-id="element-356">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-8 md:mb-10" data-id="element-357">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-3" data-id="element-358">
            {language === 'es' ? 'Nuestra Promesa' : 'Our Promise'}
          </h2>
          <p className="text-lg md:text-xl text-brand-charcoal/80 max-w-2xl mx-auto" data-id="element-359">
            {language === 'es' ? 'En Skin Glow Studio 22 no hacemos promesas que no podamos cumplir.' : 'At Skin Glow Studio 22 we do not make promises we cannot keep.'}{' '}
            <br data-id="element-360" />
            <span className="font-medium text-brand-bronze" data-id="element-361">
              {language === 'es' ? 'Prometemos tres cosas:' : 'We promise three things:'}
            </span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-362">
          {promises.map((promise, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} className="flex flex-col items-center" data-id="element-363">
              <div className="text-brand-gold mb-6" data-id="element-364">
                <FlowerIcon size={40} data-id="element-365" />
              </div>
              <h3 className="text-lg font-medium text-brand-charcoal mb-4 tracking-widest uppercase" data-id="element-366">
                {promise.title}
              </h3>
              <p className="text-brand-charcoal/70 leading-relaxed text-sm md:text-base" data-id="element-367">
                {promise.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};